import React from 'react';

const ProgressBarCellRenderer = (params) => {
  const percentage = params.value;

  if (percentage === null || percentage === undefined || isNaN(percentage)) {
    return <span>N/A</span>;
  }

  const progressStyle = {
    height: '10px',
    width: `${percentage > 100 ? 100 : percentage}%`,
    backgroundColor: percentage > 100 ? 'red' : 'green',
    transition: 'width 0.3s ease',
    borderRadius: '5px',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <div
        style={{
          flex: 1,
          backgroundColor: '#e0e0df',
          borderRadius: '5px',
          overflow: 'hidden',
          height: '10px',
        }}
      >
        <div style={progressStyle}></div>
      </div>
      <span>{`${Math.round(percentage)}%`}</span> {/* Display percentage */}
    </div>
  );
};

export default ProgressBarCellRenderer;
